import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import type { ActionCard } from "@/types/actions";
import { orpc } from "@/client";
import type { ActionDecisionResult } from "@/types/actions";

export function useActionDecision(action: ActionCard, onClose: () => void) {
	const queryClient = useQueryClient();

	return {
		onSuccess: (result: ActionDecisionResult) => {
			queryClient.invalidateQueries({ queryKey: orpc.today.key() });
			queryClient.invalidateQueries({
				queryKey: orpc.cockpit.personActions.key({ input: { person_id: action.person_id } }),
			});
			queryClient.invalidateQueries({
				queryKey: orpc.timeline.forPerson.key({ input: { person_id: action.person_id } }),
			});

			if (result.ok) {
				onClose();
			}
		},
		onError: () => toast.error("não foi possível registrar a decisão"),
	};
}
